import React from "react";
import { Link } from "react-router-dom";

const primaryBtnClass =
  "inline-flex min-h-[42px] w-full items-center justify-center rounded-md border border-slate-400/90 bg-slate-800 px-5 py-2.5 text-sm font-semibold leading-none text-white shadow-sm transition-all duration-200 hover:-translate-y-px hover:border-slate-500 hover:bg-slate-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-400 sm:w-auto";

const secondaryLinkClass =
  "inline-flex min-h-[42px] w-full items-center justify-center rounded-md border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold leading-none text-slate-800 shadow-sm transition-all duration-200 hover:-translate-y-px hover:border-slate-400 hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-400 sm:w-auto";

/**
 * In-article call-to-action card: title, supporting copy, primary action, optional secondary link.
 */
function BlogCTA({
  title,
  description,
  primaryLabel = "Start a conversation",
  primaryHref = "/contact",
  secondaryLabel,
  secondaryHref,
}) {
  const showSecondary = Boolean(secondaryLabel && secondaryHref);

  return (
    <aside
      className="mx-auto mt-10 mb-10 max-w-[640px] rounded-xl border border-slate-200 bg-slate-50 p-6 md:p-8"
      aria-label="Call to action"
    >
      <h3 className="text-lg font-semibold tracking-tight text-slate-900 md:text-xl">
        {title}
      </h3>
      <p className="mt-3 text-[15px] leading-relaxed text-slate-700 md:text-base">
        {description}
      </p>
      <div className="mt-6 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-center sm:gap-4">
        <Link to={primaryHref} className={primaryBtnClass}>
          {primaryLabel}
        </Link>
        {showSecondary ? (
          <Link to={secondaryHref} className={secondaryLinkClass}>
            {secondaryLabel}
          </Link>
        ) : null}
      </div>
    </aside>
  );
}

export default BlogCTA;
